import React from 'react';
import { node, string, bool } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldRadioButton.module.css';
import { NamedLink } from '../index';
import { FormattedMessage } from '../../util/reactIntl';

const IconRadioButton = props => {
  return (
    <div>
      <svg className={props.className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <circle
          className={
            props.showAsRequired
              ? css.required
              : props.isPremiumUser
              ? css.notChecked
              : css.notCheckedDisabled
          }
          cx="5"
          cy="19"
          r="6"
          transform="translate(2 -12)"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
        />

        <g className={css.checked} transform="translate(2 -12)" fill="none" fillRule="evenodd">
          <circle strokeWidth="2" cx="5" cy="19" r="6" />
          <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="3" />
        </g>
      </svg>
    </div>
  );
};

IconRadioButton.defaultProps = { className: null };

IconRadioButton.propTypes = { className: string };

const FieldRadioButtonComponent = props => {
  const {
    rootClassName,
    className,
    svgClassName,
    id,
    label,
    showAsRequired,
    isPremiumUser,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const radioButtonProps = {
    id,
    className: isPremiumUser ? css.input : css.inputDisabled,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  const text = isPremiumUser ? css.text : css.textDisabled;
  const radioButtonWrapper = isPremiumUser
    ? css.radioButtonWrapper
    : css.radioButtonWrapperDisabled;

  const linkToPremiumPage = !isPremiumUser && (
    <NamedLink
      className={css.premiumLink}
      name="BecomePremiumPage"
    >
      <FormattedMessage id="PaymentSelectionPage.premiumLinkText" />
    </NamedLink>
  )

  return (
    <span className={classes}>
      <Field {...radioButtonProps} />
      <label htmlFor={id} className={css.label}>
        <span className={radioButtonWrapper}>
          <IconRadioButton
            className={svgClassName}
            showAsRequired={showAsRequired}
            isPremiumUser={isPremiumUser}
          />
        </span>
        <span className={text}>{label}</span>
        <span>{linkToPremiumPage}</span>
      </label>
    </span>
  );
};

FieldRadioButtonComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  label: null,
  isPremiumUser: true,
};

FieldRadioButtonComponent.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several RadioButtones to an array of selected values
  name: string.isRequired,

  // RadioButton needs a value that is passed forward when user checks the RadioButton
  value: string.isRequired,
  isPremiumUser: bool,
};

export default FieldRadioButtonComponent;
